export default __webpack_public_path__ + "static/buy_coinbase_iphones-7e4b4c40cafefc52a9aa0fae94d10c7c.png";